import React from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router";

// Each child screen owns its own layout (TopBar + content card) so listings
// and the redesigned wizard steps aren't double-wrapped in a container.
function LeavePolicy() {
  return (
     <Box sx={{width:"100%"}}>
        <Outlet/>
     </Box>
  );
}

export default LeavePolicy;
